import React, { useEffect, useState } from 'react';
import styles from './Task_details_view.module.css';
import { AlertIconFill, CancelRedIcon, CheckMarkGreenIcon, EditIcon, TrashIcon } from '../../../../components/protected/Icons/IconsLib';
import { ActionButton, Avatar, Checkbox, Content, Dialog, DialogTrigger, Divider, Flex, Item, Link, Menu, MenuTrigger, ProgressCircle, TabList, TabPanels, Tabs, ToastQueue, View } from '@adobe/react-spectrum';
import { invokeFinderApp } from '../../../../utils/NavigationUtils';
import { useTranslation } from 'react-i18next';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { Button } from 'react-bootstrap';
import TinyMCEEditor from '../../../../components/ui/TinyMCEEditor/TinyMCEEditior';
import { SolutionStatusDropDown } from './SolutionStatusDropDown';
import { useDependency } from '../../../../contexts/DependencyProvider';
import { UpdateTaskRequest } from '../../../../services/soap/scheduler/requests/UpdateTaskRequest';
import { TaskItem } from '../../../../services/soap/dataObjects/TaskItem';
import { fromBase64Unicode } from '../../../../utils/helperUtil';
import { ChevronLeft } from 'react-bootstrap-icons';
import TaskTimelineView from './TaskTimelineView';
import TaskDocumentsView from './TaskDocumentsView';
interface ITaskDetailsViewProps {
  task: any;
  taskData?: any;
  statusList: any[];
  updateTaskStatus: (isSelected: any, ident: any, isMulti: boolean) => void;
  onEdit?: (item: boolean) => void;
  onDelete?: (item: any) => void;
  selectedItem?: any;
  updateTaskDescription: (description: string) => void;
  showUpdateDescLoader: boolean
  handleBackClick?: () => void;
  onRefreshTask?: () => Promise<any>;
}
const TaskDetailsView: React.FC<ITaskDetailsViewProps> = ({
  task,
  taskData,
  statusList,
  updateTaskStatus,
  updateTaskDescription,
  showUpdateDescLoader,
  onEdit,
  onDelete,
  handleBackClick,
  onRefreshTask,
}) => {
  const { t } = useTranslation('task');
  const _t = (key: string) => t(`task_detail.${key}`, { ns: 'task' });
  const _tt = (key: string) => t(`task_common.${key}`, { ns: 'task' });
  const [taskDescription, setTaskDescription] = useState<string>('');
  const [checkSelected, setCheckSelected] = useState(false);

  useEffect(() => {
    if (task && task.description) {
      const html = fromBase64Unicode(task.description);
      setTaskDescription(html);
    }
  }, [task])

  async function updateActivityStatus(e: any) {
    // let resActivity = await projectService.updateActivity(new UpdateActivityRequest(store.Server, store.SessionId, { ...activityData, customState: e.value }));
    // let status = activityStatusList.find((status: any) => status.id === e.value);
    // if (resActivity.result == 'OK') {
    //   await featureService.checkWorkFlowQueue(new CheckWorkFlowQueueRequest(store.Server, store.SessionId));
    //   ToastQueue.positive(t('status_updated_successfully', { ns: 'layout_components' }), { timeout: 1000 });
    //   dispatch(setSelectedItem({ item: selectedItem ? { ...selectedItem, statusName: status.name, statusColor: statusColor(status.color) } : null, show_context: false }));
    // } else {
    //   ToastQueue.negative(resActivity.EXCEPTION?.message, { timeout: 1000 });
    // }
  }

  const handleEditClicked = () => {
    if (onEdit) {
      onEdit(true);
    }
  };

  const handleDeleteClicked = () => {
    if (onDelete) {
      onDelete(task);
    }
  };

  const TaskCloseDialog = ({ close, taskId }: { close: () => void; taskId: any }) => (
    <Dialog size="S" UNSAFE_className={styles.close_pop_up_dialog} isDismissable={false}>
      <Flex UNSAFE_className={styles.close_pop_up_parent}>
        <Content UNSAFE_className={styles.close_pop_up_header}>{_t('close_task')}</Content>
        <View UNSAFE_className={styles.close_pop_up_line}></View>
        <View UNSAFE_className={styles.close_pop_up_warning_text}>{_t('confirm_text')}</View>
        <View UNSAFE_className={styles.buttons_parent_close}>
          <View UNSAFE_className={styles.button_cancel}>
            <Link width={'155px'} UNSAFE_className={styles.close_pop_up_cancel_text} isQuiet onPress={() => {
              close();
              setCheckSelected(false);
            }}>
              {_t('button_cancel')}
            </Link>
          </View>
          <View UNSAFE_className={styles.button_confirm_close}>
            <Link UNSAFE_className={styles.close_pop_up_confirm_text} isQuiet onPress={() => {
              updateTaskStatus(true, task.ident, false)
            }
            }>
              {_t('button_close')}
            </Link>
          </View>
        </View>
        <View UNSAFE_className={styles.ellipse_div}>
          <View UNSAFE_className={styles.close_alert_icon}>
            <AlertIconFill size={72} />
          </View>
        </View>
      </Flex>
    </Dialog>
  );

  const copyUrl = () => {
    const url = `${window.location.origin}/tasks?id=${task?.id}`;
    navigator.clipboard.writeText(url);
    ToastQueue.positive(_t('link_copied'), { timeout: 1000 });
  }

  return (
    <Flex width="100%" direction={'column'}>
      <View UNSAFE_className={styles.header_main}>
        <View UNSAFE_className={styles.header_child}>
          <View UNSAFE_className={styles.frame_parent}>
            <Flex alignItems={'start'} justifyContent={'space-between'} width={'100%'} wrap={'nowrap'}>
              <View UNSAFE_className={styles.icon_activity_parent}>
                {handleBackClick &&
                  <ActionButton isQuiet onPress={handleBackClick} UNSAFE_className={styles.back_button}>
                    <ChevronLeft size={20} />
                  </ActionButton>
                }
                {task.icon}
                <b title={task?.title} className={styles.activity_name}>
                  {task?.title?.length > 55 ? task?.title.substring(0, 55) + '...' : task?.title}
                </b>
              </View>
              <View UNSAFE_className={styles.icon_list_parent}>
                <SolutionStatusDropDown statusArray={statusList} selectedStatus={task.status} />
                {task.isResolved ? (
                  <Checkbox UNSAFE_style={{ transform: 'scale(1.2)', borderColor: '#B0BEC5' }} isDisabled isSelected={true}> {_t('task_done')}</Checkbox>
                ) : (
                  <>
                    <DialogTrigger isDismissable type="modal">
                      <Checkbox
                        UNSAFE_style={{ color: '#5b6c74', transform: 'scale(1.2)' }}
                        isSelected={checkSelected}
                        onChange={() => {
                          setCheckSelected(true);
                        }}
                      >
                        <span style={{ color: '#5b6c74' }}>{_t('task_done')}</span>
                      </Checkbox>
                      {close => <TaskCloseDialog close={close} taskId={task.id} />}
                    </DialogTrigger>
                  </>
                )}
                <View UNSAFE_className={styles.icon_list_child}>
                  <div className={styles.edit_icon} onClick={handleEditClicked}>
                    <EditIcon size={32} />
                  </div>
                  <div className={styles.delete_icon} onClick={handleDeleteClicked}>
                    <TrashIcon size={32} />
                  </div>
                  <MenuTrigger>
                    <ActionButton UNSAFE_style={{ border: 'none' }}>...</ActionButton>
                    <Menu onAction={copyUrl}>
                      <Item key={'copy'}>{_t('copy_link')}</Item>
                    </Menu>
                  </MenuTrigger>
                </View>
              </View>
            </Flex>
            {(task?.folderName || task?.projectName || task?.ProjectName || task?.activityName) && (
              <View UNSAFE_className={styles.folder_name_parent}>
                <View UNSAFE_className={styles.folder_name}>
                  {task?.folderName && (
                    <Link
                      UNSAFE_className={styles.folder_name_link}
                      onPress={() => invokeFinderApp(task.folderId, 'folder')}
                    >
                      {task.folderName}
                    </Link>
                  )}

                  {task?.folderName && (task?.projectName || task?.ProjectName || task?.activityName) && (
                    <span> &gt; </span>
                  )}

                  {(task?.projectName || task?.ProjectName) && (
                    <Link
                      UNSAFE_className={styles.folder_name_link}
                      onPress={() => invokeFinderApp(task.projectId, 'project')}
                    >
                      {task.projectName || task.ProjectName}
                    </Link>
                  )}

                  {(task?.projectName || task?.ProjectName) && task?.activityName && <span> &gt; </span>}

                  {task?.activityName && (
                    <Link
                      UNSAFE_className={styles.folder_name_link}
                      onPress={() => invokeFinderApp(task.activityId, 'activity')}
                    >
                      {task.activityName}
                    </Link>
                  )}
                </View>
              </View>
            )}
          </View>
          <View UNSAFE_className={styles.tag_parent} marginTop={'30px'}>
            <Flex direction={'column'} gap={'15px'} alignItems={'start'}>
              <Flex direction={'row'} gap={'size-400'}>
                <Flex direction={'column'} gap={'size-100'}>
                  <Content UNSAFE_style={{ fontSize: '14px' }}>
                    {_t('task_type')}
                  </Content>
                  <Content UNSAFE_style={{ fontSize: '14px' }}>
                    <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                      <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                        <span title={task.dateFrom}>{task.entryTypeName}</span>
                      </View>
                    </Flex>
                  </Content>
                </Flex>
                <Flex direction={'column'} gap={'size-100'}>
                  <Content UNSAFE_style={{ fontSize: '14px' }}>
                    {_t('task_solver')}
                  </Content>
                  <Content UNSAFE_style={{ fontSize: '14px' }}>
                    <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                      <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                        <span title={task.dateFrom}>{task.solver}</span>
                      </View>
                    </Flex>
                  </Content>
                </Flex>
                <Flex direction={'column'} gap={'size-100'}>
                  <Content UNSAFE_style={{ fontSize: '14px' }}>
                    {_t('task_priority')}
                  </Content>
                  <Content UNSAFE_style={{ fontSize: '14px' }}>
                    <Flex direction={'row'} UNSAFE_style={{ backgroundColor: task.priority && task.priority.color }} alignItems={'center'} justifyContent={'center'} UNSAFE_className={styles.footer_wrapper}>
                      <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                        <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                          <span title={task.timeTo}>{task.priority && task.priority.name}</span>
                        </View>
                      </Flex>
                    </Flex>
                  </Content>
                </Flex>
              </Flex>
              <Flex direction={'row'} gap={'size-100'} marginTop={'10px'}>
                <Flex direction={'column'} gap={'size-100'}>
                  <Content UNSAFE_style={{ fontSize: '14px' }}>
                    <></>
                  </Content>
                  <Content UNSAFE_style={{ fontSize: '14px' }}>
                    <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'16px'}>
                      {String(task.userList || '')
                        .split(',')
                        .map(n => n.trim())
                        .filter(Boolean)
                        .map((name, idx) => (
                          <View
                            key={`${name}-${idx}`}
                            UNSAFE_style={{ fontSize: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}
                          >
                            <Avatar src="/assets/images/avatar--desktop--light@2x.png" alt={name} />
                            <span title={name}>{name}</span>
                          </View>
                        ))}
                    </Flex>
                  </Content>
                </Flex>
              </Flex>
            </Flex>
          </View>
        </View>
      </View>
      <View>
        <Tabs aria-label="Task detail" isEmphasized>
          <TabList>
            <Item key="product">{_t('overview')}</Item>
            <Item key="communication">{_t('communication')}</Item>
            <Item key="attachments">{_t('attachments')}</Item>
          </TabList>
          <TabPanels>
            <Item key="product">
              <Flex direction={'row'} marginTop="size-100">
                <Flex direction="column"
                  gap="size-100" gridArea="detail" width='100%'>
                  <View UNSAFE_className={styles.productMainTitle}>
                    {_t('description')}
                  </View>
                  <Flex
                    direction={'column'}
                    gap={'size-100'}
                    justifyContent={'end'}
                  >
                    <Flex
                      direction={'column'}
                      position={'relative'}
                      width={'100%'}
                      height={'100%'}
                      alignItems={'start'}
                      justifyContent={'start'}
                      zIndex={0}
                      flex={1}
                      minHeight={'200px'}
                      gridRow={'20'}>
                      <TinyMCEEditor
                        key={'tiny_editor_mobile'}
                        initialValue={taskDescription}
                        onChange={(e: any) => {
                          setTaskDescription(e);
                        }}
                        height={'100%'}
                      />
                    </Flex>
                    <Flex direction={'row'} justifyContent={'end'}>
                      <ProgressCircle aria-label='....Loading' isHidden={!showUpdateDescLoader} isIndeterminate UNSAFE_style={{ marginRight: '20px', marginTop: '10px' }} />
                      <Button variant="primary"
                        style={{ alignSelf: 'flex-end', marginTop: '10px', backgroundColor: '#0B5FFF', borderColor: '#0B5FFF' }}
                        onClick={() => { updateTaskDescription(taskDescription) }}
                      >
                        {_tt('button_save')}
                      </Button>
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
            </Item>
            <Item key="communication">
              <View marginTop="size-100">
                <TaskTimelineView task={task} taskStatusList={statusList} />
              </View>
            </Item>
            <Item key="attachments">
              <View marginTop="size-100">
                <TaskDocumentsView task={taskData || task} onRefreshTask={onRefreshTask} />
              </View>
            </Item>
          </TabPanels>
        </Tabs>
      </View>
    </Flex>
  );
};

export default TaskDetailsView;
